<template>
  <div class="pnf">
    <div class="row top">
      <div class="col header-text">
        <h1>Page Not Found</h1>
      </div>
    </div>
    <div class="container">
      <div class="row">
        <div class="col-lg-12">
          <h3>Error 404</h3>
          Oops. Something obviously isn’t right if you’re reading this. The URL you entered or followed no longer seems to exist, has been removed, or has been replaced. If you feel that this an error
          that needs to be addressed, feel free to contact the administrator of this website. Thank you!
          <div class="back-btn">
            <b-button to="/">Return to front page</b-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'PageNotFound',
  head () {
    return {
      meta: [
        { name: 'robots', content: 'noindex' }
      ]
    }
  }
}
</script>

<style scoped lang="scss">

.pnf {
  .top {
    margin-bottom: 10px;
  }
}

.header-text {
  font-weight: bold;
  margin: 52px auto 16px 5%;

  h1 {
    font-style: normal;
    font-weight: bold;
    font-size: 64px;
    line-height: 64px;
    text-align: center;
    color: #000000;
    flex: none;
    max-width: 725px;
    margin: auto auto 15px;
  }
}

.text-header {
  margin: 45px auto 12px 1%;
  font-weight: bold;
}

.back-btn {
  margin-top: 15px;
  margin-bottom: 15px;
}
</style>
